import React from 'react';
import { UseControllerProps } from 'react-hook-form/dist/types/controller';

import { FormGroupEssentialProps, RadioGroup, RadioGroupProps } from '../../../components';

import { ConnectedComponentProps, ConnectHelper } from './ConnectHelper';

export type FormRadioGroupProps = RadioGroupProps &
  FormGroupEssentialProps & {
    name: string;
    rules?: UseControllerProps['rules'];
  };

const RadioGroupInner = ({ componentProps, controllerField }: ConnectedComponentProps<FormRadioGroupProps>) => (
  <RadioGroup
    {...componentProps}
    {...controllerField}
    onChange={(newValue, e) => {
      controllerField?.onChange(newValue);

      componentProps.onChange?.(newValue, e);
    }}
    onBlur={(e) => {
      controllerField?.onBlur();

      componentProps.onBlur?.(e);
    }}
  />
);

export const ConnectedRadioGroup = (props: FormRadioGroupProps) => (
  <ConnectHelper<FormRadioGroupProps> {...props} RenderComponent={RadioGroupInner} />
);
